import { Routes } from '@angular/router';
import { verificacionGuard } from './features/auth/guards/verificacion.guard';
import { loginGuard } from './features/auth/guards/login.guard';

export const routes: Routes = [
  {
    path: 'auth/supervision',
    loadComponent: () =>
      import('./features/auth/pages/supervision-page/supervision-page').then(
        (m) => m.SupervisionPage,
      ),
  },
  { path: 'profile', loadChildren: () => import('./features/profile/profile.routes').then(m => m.PROFILE_ROUTES) },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./features/home/pages/home-page/home-page').then(
        (m) => m.HomePage,
      ),
  },
  {
    path: 'history',
    loadComponent: () =>
      import('./features/history/pages/history-page/history-page').then(
        (m) => m.HistoryPage,
      ),
  },
  {
    path: 'fixture',
    loadComponent: () =>
      import('./features/fixture/pages/fixture-page/fixture-page').then(
        (m) => m.FixturePage,
      ),
  },
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () =>
      import('./features/auth/pages/login-page/login-page').then(
        (m) => m.LoginPage,
      ),
  },
  {
    path: 'login/verification',
    loadComponent: () =>
      import('./features/auth/pages/verificacion-page/verificacion-page').then(
        (m) => m.VerificacionPage,
      ),
    canActivate: [verificacionGuard],
  },
  {
    path: 'login/complete-profile',
    loadComponent: () =>
      import('./features/auth/pages/completar-perfil-page/completar-perfil-page').then(
        (m) => m.CompletarPerfilPage,
      ),
    canActivate: [verificacionGuard],
  },
  {
    path: 'tickets',
    loadComponent: () =>
      import('./features/tickets/pages/ticketing-events-page/ticketing-events-page').then(
        (m) => m.TicketingEventsPage,
      ),
  },
  {
    path: 'abono-edil/checkout-v2',
    loadChildren: () => import('./features/tickets/checkout-v2/checkout-v2.routes').then(m => m.PASS_CHECKOUT_V2_ROUTES),
  },
  {
    path: 'abono-edil',
    title: 'Abono Edil 2026 | Deportivo Municipal',
    loadComponent: () =>
      import('./features/tickets/pages/season-pass-page/season-pass-page').then(
        (m) => m.SeasonPassPage,
      ),
  },
  {
    path: 'tickets/:id',
    loadComponent: () =>
      import('./features/tickets/pages/tickets-page/tickets-page').then(
        (m) => m.TicketsPage,
      ),
  },
  {
    path: 'ticket-cart',
    loadComponent: () =>
      import('./features/tickets/pages/ticket-cart-page/ticket-cart-page').then(
        (m) => m.TicketCartPage,
      ),
  },
  {
    path: 'checkout/confirmation',
    loadComponent: () =>
      import('./features/purchase/pages/payment-success-page/payment-success-page.component').then(
        (m) => m.PaymentSuccessPageComponent,
      ),
  },
  {
    path: 'attendees',
    loadComponent: () =>
      import('./features/tickets/pages/attendees-page/attendees-page').then(
        (m) => m.AttendeesPage,
      ),
  },
  {
    path: 'sponsors',
    loadComponent: () =>
      import('./features/sponsors/pages/sponsors-page/sponsors-page').then(
        (m) => m.SponsorsPage,
      ),
  },
  {
    path: 'members',
    // Seccion en preparacion: se muestra ComingSoon (mismo patron que 'edil-play') mientras se completa members-page.
    loadComponent: () =>
      import('./shared/coming-soon/coming-soon').then((m) => m.ComingSoon),
    data: {
      titulo: 'Hazte Socio',
      descripcion: 'Muy pronto vas a poder hacerte socio del Deportivo Municipal y acceder a todos los beneficios exclusivos. ¡Estamos ultimando detalles!',
    },
  },
  {
    path: 'members/edil-member',
    loadComponent: () =>
      import('./features/members/pages/edil-member-page/edil-member-page').then(
        (m) => m.EdilMemberPage,
      ),
  },
  {
    path: 'store',
    loadChildren: () =>
      import('./features/store/store.routes').then((m) => m.STORE_ROUTES),
  },
  {
    path: 'news',
    loadComponent: () =>
      import('./features/news/pages/news-page/news-page').then(
        (m) => m.NewsPage,
      ),
  },
  {
    path: 'news/:id',
    loadComponent: () =>
      import('./features/news/pages/news-page/news-page').then(
        (m) => m.NewsPage,
      ),
  },
  {
    path: 'matches',
    loadComponent: () =>
      import('./features/matches/pages/matches-page/matches-page').then(
        (m) => m.MatchesPage,
      ),
  },
  {
    path: 'table',
    loadComponent: () =>
      import('./features/matches/pages/matches-page/matches-page').then(
        (m) => m.MatchesPage,
      ),
  },
  {
    path: 'academy',
    loadComponent: () =>
      import('./features/academy/pages/academy-page/academy-page').then(
        (m) => m.AcademyPage,
      ),
  },
  {
    path: 'squad',
    loadComponent: () =>
      import('./features/squad/pages/squad-page/squad-page').then(
        (m) => m.SquadPage,
      ),
  },
  // Redirects de compatibilidad: las rutas de la tienda pasaron de /tienda a /store.
  { path: 'tienda', redirectTo: 'store' },
  { path: 'tienda/detalle/:id', redirectTo: 'store/product/:id' },
  { path: 'tienda/carrito', redirectTo: 'store/cart' },
  { path: 'tienda/invitado', redirectTo: 'store/guest' },
  { path: 'tienda/entrega', redirectTo: 'store/shipping' },
  { path: 'tienda/confirmacion', redirectTo: 'store/confirmation' },
  { path: 'tienda/pago', redirectTo: 'store/payment' },
  // Redirects de compatibilidad: rutas antiguas en español a sus equivalentes en inglés.
  { path: 'historia', redirectTo: 'history' },
  { path: 'ingresar', redirectTo: 'login' },
  { path: 'ingresar/verificacion', redirectTo: 'login/verification' },
  { path: 'ingresar/completa-perfil', redirectTo: 'login/complete-profile' },
  { path: 'entradas', redirectTo: 'tickets' },
  { path: 'carrito-compra', redirectTo: 'ticket-cart' },
  { path: 'compra/confirmacion', redirectTo: 'checkout/confirmation' },
  { path: 'asistentes', redirectTo: 'attendees' },
  { path: 'socios', redirectTo: 'members' },
  { path: 'socios/socio-edil', redirectTo: 'members/edil-member' },
  { path: 'noticias', redirectTo: 'news' },
  { path: 'noticias/:id', redirectTo: 'news/:id' },
  { path: 'partidos', redirectTo: 'matches' },
  { path: 'tabla', redirectTo: 'table' },
  { path: 'academias', redirectTo: 'academy' },
  { path: 'plantel', redirectTo: 'squad' },
  { path: '**', redirectTo: '' },
];
